// @ts-strict-ignore
/** @jsx jsx */

import { jsx } from 'theme-ui'
import React from 'react'
import { Container } from '../helpers/react'
import LoadingState from './loading-state.connected'
import FilterBlock from './filter-block.connected'
import Pagination from './pagination.connected'
import Table from './table.connected'
import { trackEvent } from '../../utils/tracking'
import ProductTableErrorBlock from './product-table-error-block'

export const DatasetContext = React.createContext()

const TableWrapper = ({ dataset, loadingLabel, variant = 'rich', product_id, ...props }) => {
  const datasetId = dataset?.sys?.id
  const productTableId = props?.sys?.id
  return (
    <DatasetContext.Provider value={{ datasetId, productTableId }}>
      <Container data-fs-core-product-table-wrapper={variant}>
        <ProductTableErrorBlock datasetId={datasetId} {...props} />
        <FilterBlock
          variant={variant}
          datasetId={datasetId}
          productTableSchemaId={props?.schema?.sys?.id}
          productTableId={props?.sys.id}
        />
        <LoadingState label={loadingLabel} datasetId={datasetId}>
          <Table
            dataset={dataset}
            variant={variant}
            onClickEligibility={trackEvent}
            product_id={product_id}
            {...props}
          />
        </LoadingState>
        <Pagination variant={variant} datasetId={datasetId} productTableId={props?.sys.id} />
      </Container>
    </DatasetContext.Provider>
  )
}

export default TableWrapper
